const env = {
  API_ROOT_PATH: process.env.REACT_APP_API_ROOT_PATH,
  CLOUDINARY_NAME: process.env.REACT_APP_CLOUDINARY_NAME,
  FE_URL: process.env.REACT_APP_FE_URL
};

export default env;
